import Defaults from '~/scripts/constants/defaults';

/* globals Knitiv */

/**
 * @typedef FileCurrentScope
 *
 * @property {Defaults} Defaults
 * @property {import('~/scripts/services/model/file-upload').default | undefined} file
 * @property {import('~/scripts/services/model/file-upload').default[]} files
 * @property {import('~/scripts/services/model/form').default} form
 * @property {boolean} kds
 * @property {string} path
 *
 * @property {Function} addFiles
 * @property {Function} detachFile
 * @property {Function} download
 * @property {Function} openTabFile
 */

export default /* @ngInject */ (
	/** @type {import('angular').auto.IInjectorService} */ $injector,
	/** @type {import('angular').ILocationService} */ $location,
	/** @type {Knitiv.RootScope} */ $rootScope,
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {FileCurrentScope} */ $scope,
	/** @type {import('~/scripts/services/form.service').default} */ FormService,
	/** @type {import('~/components/download/download.service').FileDownloadServiceModel} */ FileDownloadService,
) => {
	$scope.Defaults = Defaults;
	$scope.kds = $rootScope.kds;

	if ($scope.file?.file) {
		$scope.files.push($scope.file);
	}

	/**
	 * @param {File} file
	 * @param {File[]} files
	 */
	$scope.addFiles = (file, files) => {
		if ($scope.kds) {
			$scope.form.addFiles(files)
		}
		else {
			$scope.form.addFile(file)
		}
	}

	/**
	 * Removes a file from the specified form
	 *
	 * @param {number} k
	 */
	$scope.detachFile = async k => {
		if ($scope.form) {
			const resultDetachFile = await $scope.form.detachFile($scope.files[k]);
			if (resultDetachFile) {
				$scope.files.splice(k, 1);
			}
		}
	};

	/**
	 * Downloads the file of the current form
	 */
	$scope.download = async () => {
		if ($scope.form?.checkDroit(Defaults.DROIT.READ)) {
			await FileDownloadService.download([{ kid: $scope.form.kid }]);
		}
	};

	$scope.path = $location.path();

	$scope.openTabFile = (/** @type {string} */ id) => {
		$location.search({
			tab: 'file',
			id,
		});
	};
};
